import React from 'react';
import ContentLoader from '../../../common/components/ContentLoader';
import RectLoader from '../../../common/components/RectLoader';
import { useTheme } from '@hmsexp/component-library';
import { View } from 'react-native';
import homeLoaderStyle from './styles';

const HomeLoader = () => {
  const { palette } = useTheme();
  return (
    <View style={homeLoaderStyle.mainWrapper}>
      <ContentLoader
        speed={2}
        width={'100%'}
        height={'100%'}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}
      >
        <RectLoader x='0'
          y='0'
          rx='3'
          ry='3'
          width='50%'
          height='20'
        />
        <RectLoader x='0'
          y='30'
          rx='3'
          ry='3'
          width='60%'
          height='20'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
        <RectLoader x='0'
          y='60'
          rx='3'
          ry='3'
          width='100%'
          height='48'
        />
      </ContentLoader>
    </View>
  );
};

export default HomeLoader;
